﻿import { FC } from 'react';
import { CarouselProps, CarouselOptions } from '@u1/fixers';
import { useU1Carousel } from '../hooks';
import { ComponentProps } from '../shared/types';
import { U1Base } from './base';

export const U1Carousel: FC<ComponentProps<CarouselProps, CarouselOptions>> = (props) =>
  U1Base(useU1Carousel, props);
